import dayjs from 'dayjs'

export const getTimeData = (dates, date) => {
  const [month, day, year] = dayjs(date).format('MM/DD/YYYY').split('/')
  const monthData = dates && dates[`${month}/${year}`]

  return monthData && monthData[day]
}

export const getNextDayTimeData = (dates, date) => {
  if (!dates) {
    return
  }
  const currentDate = dayjs(date)
  let nextDate = currentDate.add(1, 'day')
  for (;;) {
    const [month, day, year] = nextDate.format('MM/DD/YYYY').split('/')
    const monthData = dates[`${month}/${year}`]

    if (!monthData) {
      return {
        date: null,
        data: []
      }
    }

    if (monthData[day] && monthData[day].length > 0) {
      return {
        date: nextDate.toISOString(),
        data: monthData[day]
      }
    }
    nextDate = nextDate.add(1, 'day')
  }
}

export const getFormattedDate = date => dayjs(date).format('MMM. D')
